import React from "react";
import { useSelector } from "react-redux";
import PieChart from "../../../../components/charts/pieChart/pieChart";
import NoData from "../../../../components/noData/noData";

const ClosingPieChart = () => {
  const closingBreakdown = useSelector(
    (state) => state.firstRiders.firstTimeRiders.closingBreakdown
  );
  return closingBreakdown?.length !== 0 ? (
    <PieChart data={closingBreakdown} clickablePie showLegend legendPosition="right" />
  ) : (
    <NoData />
  );
};

export default ClosingPieChart;
